var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.change_test_mask}},[_c('div',{staticClass:"test_mask"}),_c('img',{class:_vm.type == 'd' ? 'd' : 'r',attrs:{"src":require("@/assets/img/h5/hand.gif")}})])}
var staticRenderFns = []

export { render, staticRenderFns }